export default "__VITE_ASSET__BIuc70aw__"